import { cn } from "@/lib/utils";

interface AuthPageFooterProps {
    children?: React.ReactNode;
    className?: string;
}

/** In-card footer: help links, terms, or secondary actions. */
export function AuthPageFooter({ children, className }: AuthPageFooterProps) {
    if (!children) return null;

    return (
        <div className={cn("pt-4 border-border border-t text-muted-foreground text-sm leading-relaxed", className)}>
            {children}
        </div>
    );
}
